export default {"src":"/_next/static/media/nextBtn.dab7530a.svg","height":39,"width":39};